import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from 'store';

// ROOT APP COMPONENT
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// SITE SETTINGS CONTEXT
import SettingsProvider from 'contexts/settingsContext';
import './index.css';

// ALL THIRD PARTY LIBRARIES CSS
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'nprogress/nprogress.css';
import 'react-quill/dist/quill.snow.css';
import 'simplebar-react/dist/simplebar.min.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { SignalRProvider } from './contexts/signalerContext';
import { Toaster } from 'react-hot-toast';
import { setTokenRefreshCallback } from './api';
import { AuthActions } from './store/reducers/auth';

const token = localStorage.getItem('token') || sessionStorage.getItem('token');

setTokenRefreshCallback((newToken) => {
  store.dispatch(AuthActions.updateToken(newToken));
});

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode> // (если необходимо)

  <ErrorBoundary>
    <ReduxProvider store={store}>
      <SignalRProvider token={token}>
        <SettingsProvider>
          <Toaster />
          <App />
        </SettingsProvider>
      </SignalRProvider>
    </ReduxProvider>
  </ErrorBoundary>

  // </React.StrictMode>
);
